<template>
  <b-card no-body>
    <window-tabs card ref="tabs" v-model="tabIndex" :close="close">
      <slot></slot>
      <template slot="tabs">
        <slot name="tabs"></slot>
      </template>
    </window-tabs>
  </b-card>
</template>

<script>
  import { windowIdMixin } from '../mixins/index'
  import { mapWindowData } from '../utils/index'
  import * as action from '../store/action-types'

  export default {
    mixins: [windowIdMixin],
    computed: {
      ...mapWindowData({'tabIndex': {default: 0}})
    },
    methods: {
      close () {
        this.$store.dispatch(action.WINDOW_CLOSE, {windowId: this.windowId})
        this.$emit('closed')
      }
    },
    mounted () {
      this.$shortcut.setContext(this.windowId)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/window.vue